import React, { FC } from 'react';
import { ImageBasePage } from '@components';
import { ChangePasswordV2 } from '@fdha/web-auth';
import { useLocalStorage } from '@hooks';

interface ChangePasswordProps {
  termsOfServiceLink: string;
  privacyPolicyLink: string;
}

const ChangePassword: FC<ChangePasswordProps> = ({
  termsOfServiceLink,
  privacyPolicyLink,
}) => {
  const { saveToLocalStorage } = useLocalStorage('me', false);

  const handleRememberMe = (rememberMe: boolean, userId: string) => {
    saveToLocalStorage(
      {
        rememberMe,
        isAuthenticated: true,
        lastLogin: new Date(),
      },
      false,
      `pat_${userId}`
    );
  };

  return (
    <ImageBasePage
      image={{
        url: '/images/woman_02.png',
        altText: 'Old Woman',
      }}
      title="Set password"
      i18nKeyTitle="login:changePassword.setPassword"
      titleVariant="h4"
      alignHeader="flex-start"
    >
      <ChangePasswordV2
        showTosToggle
        termsOfServiceLink={termsOfServiceLink}
        privacyPolicyLink={privacyPolicyLink}
        handleRememberMe={handleRememberMe}
      />
    </ImageBasePage>
  );
};

export default ChangePassword;
